/**
 * Public wire constants — all sourced from the Rust core so every
 * language binding agrees byte-for-byte. To switch dev ↔ prod, edit
 * `core/src/constants.rs` and rebuild the native binding; no edits
 * here are needed.
 */
import { native } from "./native.js";

export const DEFAULT_ENDPOINT: string = native.DEFAULT_ENDPOINT;

export const DEFAULT_CHROMIA_NODE_URLS: readonly string[] = Object.freeze(
  native.defaultChromiaNodeUrls(),
);

export const DEFAULT_BLOCKCHAIN_RID: string = native.DEFAULT_BLOCKCHAIN_RID;
